export class CareServiceAreaStore {
  constructor(private readonly _baseUrl: string) {}

  public index(): string {
    return `${this._baseUrl}/care-service-areas/`;
  }

  public details(careServiceAreaId: number): string {
    return `${this._baseUrl}/care-service-areas/${careServiceAreaId}`;
  }

  public administrativeRegions(): string {
    return `${this._baseUrl}/care-service-areas/administrative-regions`;
  }

  public administrativeDistricts(): string {
    return `${this._baseUrl}/care-service-areas/administrative-districts`;
  }

  public postalCodes(): string {
    return `${this._baseUrl}/care-service-areas/postal-codes`;
  }
}
